import React from "react";
import { INTERVAL_ORDER, INTERVAL_LABELS, savingsPct } from "@/lib/billing";

/**
 * Segmented control for choosing the billing interval (Monthly / 6 Months / 12 Months).
 * Shows a small savings badge on annual/6-month options when cheaper per month.
 */
export const BillingToggle = ({ value, onChange, options, savingsPlan = "pro", bestValueInterval = null, className = "" }) => (
  <div className={`inline-flex rounded-xl border bg-card p-1 ${className}`} data-testid="billing-toggle">
    {INTERVAL_ORDER.map((interval) => {
      const active = value === interval;
      const pct = options ? savingsPct(options, savingsPlan, interval) : 0;
      const isBest = bestValueInterval && interval === bestValueInterval;
      return (
        <button
          key={interval}
          type="button"
          onClick={() => onChange(interval)}
          data-testid={`billing-toggle-${interval}`}
          aria-pressed={active}
          className={`relative rounded-lg px-4 py-2 text-sm font-medium transition-colors ${
            active ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:text-foreground"
          }`}
        >
          {isBest && (
            <span
              className="pointer-events-none absolute -top-2.5 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-[hsl(var(--risk-low))] px-2 py-0.5 text-[10px] font-semibold text-white shadow-sm"
              data-testid={`billing-toggle-bestvalue-${interval}`}
            >
              Best value
            </span>
          )}
          {INTERVAL_LABELS[interval]}
          {pct > 0 && (
            <span className={`ml-1.5 rounded-full px-1.5 py-0.5 text-[10px] font-semibold ${
              active ? "bg-primary-foreground/20 text-primary-foreground" : "bg-[hsl(var(--risk-low-bg))] text-[hsl(var(--risk-low))]"
            }`}>
              -{pct}%
            </span>
          )}
        </button>
      );
    })}
  </div>
);
